/* container.tsx generated by @compiled/babel-plugin v0.36.1 */
import "./container.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
const containerStyles = null;
/* Use max-width so the component can shrink on smaller viewports. */
const wideContainerStyles = null;
const narrowContainerStyles = null;
/**
 * __Container__
 *
 * Upper level container for Empty State.
 *
 * @internal
 */
const Container = ({
  children,
  width,
  testId
}) => /*#__PURE__*/React.createElement("div", {
  "data-testid": testId,
  className: ax(["_6rthoahv _1pfhoahv _12l21wug _ahbq1wug _y3gn1h6o", width === 'narrow' ? "_p12fko4j" : "_p12f1pl1"])
}, children);
export default Container;